import { OverlayTrigger,Tooltip} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const InformationTooltip = ({ text }) => {
    return (
        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-taxDue">{text}</Tooltip>}>
            <FontAwesomeIcon color='gray' icon={faCircleInfo} style={{ marginLeft: 10 }} />
        </OverlayTrigger>
    );
};

export default InformationTooltip;
